let timeoutId = null;

const LOGOUT_TIME = 10 * 60 * 1000; // 10 минут

function logout() {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("user");

  window.location.href = "/login";
}

function resetTimer() {
  clearTimeout(timeoutId);

  const token = localStorage.getItem("access");

  if (!token) return;

  timeoutId = setTimeout(
    logout,
    LOGOUT_TIME
  );
}

export function initIdleLogout() {

  const events = [
    "mousemove",
    "mousedown",
    "keypress",
    "scroll",
    "touchstart",
    "click"
  ];

  events.forEach((event) => {
    window.addEventListener(
      event,
      resetTimer
    );
  });

  resetTimer();
}
